import { COMMERCE_PAYMENT_TYPE_ID, INVOICE_TYPE_ID, MEETING_EVENT_TYPE_ID, QUOTE_TYPE_ID, SUBSCRIPTION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
export const getShowPropertiesAppLinks = objectType => {
  const objectTypeId = normalizeTypeId(objectType);
  if (objectTypeId === SUBSCRIPTION_TYPE_ID || objectTypeId === COMMERCE_PAYMENT_TYPE_ID || objectTypeId === INVOICE_TYPE_ID || objectTypeId === MEETING_EVENT_TYPE_ID || objectTypeId === QUOTE_TYPE_ID) {
    return false;
  }
  return true;
};